import { useCallback } from 'react';
import { getSuggestedQuestions } from '../../../services/chatService';
import { useScrollToBottom } from './useScrollToBottom';

interface UseSuggestedQuestionsProps {
    thread_id: string;
    account_id: string;
    setSuggestedQuestions: React.Dispatch<React.SetStateAction<any>>;
    setIsLoadingSuggestions: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useSuggestedQuestions = ({
    thread_id,
    account_id,
    setSuggestedQuestions,
    setIsLoadingSuggestions,
}: UseSuggestedQuestionsProps) => {
    const { scrollToBottom } = useScrollToBottom();

    const fetchSuggestedQuestions = useCallback(async (messageType?: 'text' | 'ui' | null) => {
        if (!thread_id || messageType === 'ui') return;

        setIsLoadingSuggestions(true);
        scrollToBottom(100);

        try {
            const suggestions = await getSuggestedQuestions(thread_id, account_id);
            setSuggestedQuestions(suggestions);
        } catch (error) {
            console.error('获取建议问题失败:', error);
            setSuggestedQuestions(null);
        } finally {
            setIsLoadingSuggestions(false);
            scrollToBottom(100);
        }
    }, [thread_id, scrollToBottom, setIsLoadingSuggestions, setSuggestedQuestions]);

    const clearSuggestedQuestions = useCallback(() => {
        setSuggestedQuestions(null);
    }, [setSuggestedQuestions]);

    return {
        fetchSuggestedQuestions,
        clearSuggestedQuestions,
    };
};
